module.exports = __webpack_public_path__ + "img/riointbig5.6cad63fc.png";